/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Country_Count_Plural_LabelInputs */

const bn_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দেশগুলি`)
};

const de_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Länder`)
};

const el_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`χωρών`)
};

const en_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`countries`)
};

const es_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`países`)
};

const fr_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pays`)
};

const hi_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देशों`)
};

const hu_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`országokban`)
};

const id_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`negara`)
};

const it_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paesi`)
};

const ja_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国`)
};

const ko_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`국가`)
};

const nl_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`landen`)
};

const pl_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kraje`)
};

const pt_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`países`)
};

const ru_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`страны`)
};

const sv_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`länder`)
};

const tr_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ülkeler`)
};

const uk_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`країни`)
};

const vi_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`các nước`)
};

const zh_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国家`)
};

const zh_hant_country_count_plural_label = /** @type {(inputs: Country_Count_Plural_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`國家`)
};

/**
* | output |
* | --- |
* | "countries" |
*
* @param {Country_Count_Plural_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const country_count_plural_label = /** @type {((inputs?: Country_Count_Plural_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Country_Count_Plural_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_country_count_plural_label(inputs)
	if (locale === "de") return de_country_count_plural_label(inputs)
	if (locale === "el") return el_country_count_plural_label(inputs)
	if (locale === "en") return en_country_count_plural_label(inputs)
	if (locale === "es") return es_country_count_plural_label(inputs)
	if (locale === "fr") return fr_country_count_plural_label(inputs)
	if (locale === "hi") return hi_country_count_plural_label(inputs)
	if (locale === "hu") return hu_country_count_plural_label(inputs)
	if (locale === "id") return id_country_count_plural_label(inputs)
	if (locale === "it") return it_country_count_plural_label(inputs)
	if (locale === "ja") return ja_country_count_plural_label(inputs)
	if (locale === "ko") return ko_country_count_plural_label(inputs)
	if (locale === "nl") return nl_country_count_plural_label(inputs)
	if (locale === "pl") return pl_country_count_plural_label(inputs)
	if (locale === "pt") return pt_country_count_plural_label(inputs)
	if (locale === "ru") return ru_country_count_plural_label(inputs)
	if (locale === "sv") return sv_country_count_plural_label(inputs)
	if (locale === "tr") return tr_country_count_plural_label(inputs)
	if (locale === "uk") return uk_country_count_plural_label(inputs)
	if (locale === "vi") return vi_country_count_plural_label(inputs)
	if (locale === "zh") return zh_country_count_plural_label(inputs)
	return zh_hant_country_count_plural_label(inputs)
});